import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { InternalDynamicParameters, } from '../../../../dynamic-params/src/lib/models/dynamic-parameters';
import { TranslateService } from '@ngx-translate/core';
export const dynamicParameters = new Map([
    [InternalDynamicParameters.click_id, 'click_id'],
    [InternalDynamicParameters.external_click_id, 'external_click_id'],
    [InternalDynamicParameters.browser, 'browser'],
    [InternalDynamicParameters.ip, 'ip'],
    [InternalDynamicParameters.traffic_source, 'traffic_source'],
    [InternalDynamicParameters.country_iso_code, 'country_iso_code'],
    [InternalDynamicParameters.language_iso_code, 'language_iso_code'],
    [InternalDynamicParameters.commission_type, 'commission_type'],
    [InternalDynamicParameters.rule_price, 'rule_price'],
    [InternalDynamicParameters.p1, 'p1'],
    [InternalDynamicParameters.p2, 'p2'],
    [InternalDynamicParameters.p3, 'p3'],
    [InternalDynamicParameters.p4, 'p4'],
    [InternalDynamicParameters.p5, 'p5'],
    [InternalDynamicParameters.p6, 'p6'],
    [InternalDynamicParameters.p7, 'p7'],
    [InternalDynamicParameters.p8, 'p8'],
    [InternalDynamicParameters.p9, 'p9'],
    [InternalDynamicParameters.p10, 'p10'],
]);
let DynamicParametersService = class DynamicParametersService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = dynamicParameters;
    }
    list() {
        return this._data;
    }
    get(param) {
        const p = this._data.get(param);
        return p ? this._translate.instant(p) : p;
    }
};
DynamicParametersService.ctorParameters = () => [
    { type: TranslateService }
];
DynamicParametersService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], DynamicParametersService);
export { DynamicParametersService };
